import Vue from "vue";

import {
  ConnectWallet,
  disconnect,
  monitorWallet,
  toFixedTwo,
  convertHoursToTimestamp,
  convertDaysToTimestamp,
  convertTimestampToInternationalDate,
  convertStandardDateToTimestamp,
  convertTimestampToStandardDate,
  getCurrenLondonTime
} from "./wallet";
Vue.mixin({
  methods: {
    ConnectWallet,
    disconnect,
    monitorWallet,
    toFixedTwo,
    convertHoursToTimestamp,
    convertDaysToTimestamp,
    convertTimestampToInternationalDate,
    convertStandardDateToTimestamp,
    convertTimestampToStandardDate,
    getCurrenLondonTime
  },
});
